import { DataGridCellParams } from "@components/common/data-grid/adm-data-grid-types";
import { AdmPlan } from "@custom-types/base-types";

/** The column definition for the hardware table with the field property typed */
export type HardwareTableGridColDef = DataGridCellParams<
  AdmPlan,
  HardwareTableColumnField
>;

/** The column fields that can be used in the hardware table */
export type HardwareTableColumnField =
  | "licenseName"
  | "status"
  | "assignedTo"
  | "serialNumber"
  | "startDate"
  | "expirationDate"
  | "options";

/** The labels for the columns in the hardware table */
export const HARDWARE_TABLE_COLUMN_LABELS: Record<
  HardwareTableColumnField,
  string
> = {
  licenseName: "License Name",
  status: "Status",
  assignedTo: "Assigned To",
  serialNumber: "Serial Number",
  startDate: "Start Date",
  expirationDate: "Expiration Date",
  options: "",
};
